export default __webpack_public_path__ + "static/media/bacohtlogo.6eb2d254.png";